module.exports = __webpack_public_path__ + "static/media/bp-bottom.c234e731.webp";